module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-calcul-paie",
    attrs: {
      "data-testid": "calculPaie-section"
    },
    on: {
      "click": function($event) {
        _vm.closeToolTips()
      }
    }
  }, [_c('div', {
    staticClass: "left noselect mr-3"
  }, [_c('div', {
    staticClass: "area",
    attrs: {
      "data-testid": "calculPaie-contrats"
    }
  }, [_c('div', {
    staticClass: "head mb-2"
  }, [_c('div', {
    staticClass: "title-head mr-2",
    attrs: {
      "data-testid": "calculPaie-contrats-title"
    }
  }, [_vm._v("Contrats")]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "wrap"
  }, [_c('button', {
    staticClass: "inp-button ml-2 blue",
    attrs: {
      "type": "button",
      "title": "Calculer les bulletins",
      "data-testid": "calculPaie-calculer-button"
    },
    on: {
      "click": function($event) {
        _vm.onLancerCalculs()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-play mr-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Calculer")])]), _vm._v(" "), _c('button', {
    staticClass: "inp-button ml-2 green",
    attrs: {
      "type": "button",
      "title": "Réinitialiser les bulletins",
      "data-testid": "calculPaie-reinitialiser-button"
    },
    on: {
      "click": function($event) {
        _vm.onRazCalculs()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-sync-alt mr-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Réinitialiser")])]), _vm._v(" "), _c('button', {
    staticClass: "inp-button ml-2 orange",
    attrs: {
      "type": "button",
      "title": "Éditer les bulletins",
      "data-testid": "calculPaie-editer-button"
    },
    on: {
      "click": function($event) {
        _vm.imprimer()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-print mr-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Éditer")])]), _vm._v(" "), _c('div', {
    staticClass: "inp-input-mini icon ml-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterName),
      expression: "filterName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": "Rechercher",
      "data-testid": "calculPaie-search-input"
    },
    domProps: {
      "value": (_vm.filterName)
    },
    on: {
      "keyup": function($event) {
        _vm.doFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filterName.length == 0) ? _c('span', {
    staticClass: "icon-inner fas fa-search"
  }) : _c('span', {
    staticClass: "icon-inner fas fa-times cls",
    on: {
      "click": function($event) {
        _vm.filterName = '';
        _vm.doFilter()
      }
    }
  })]), _vm._v(" "), (_vm.isAdministrateur) ? _c('div', {
    staticClass: "inp-input-mini icon ml-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeRubrique),
      expression: "codeRubrique"
    }],
    staticClass: "input input-caps",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": "Code Rubrique"
    },
    domProps: {
      "value": (_vm.codeRubrique)
    },
    on: {
      "keyup": function($event) {
        _vm.doFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codeRubrique = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.codeRubrique.length == 0) ? _c('span', {
    staticClass: "icon-inner fas fa-search"
  }) : _c('span', {
    staticClass: "icon-inner fas fa-times cls",
    on: {
      "click": function($event) {
        _vm.codeRubrique = '';
        _vm.doFilter()
      }
    }
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inp-table noselect",
    attrs: {
      "data-testid": "calculPaie-table"
    }
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th cln-check center-flex nohover",
    attrs: {
      "title": "Tout sélectionner"
    }
  }, [_c('div', {
    staticClass: "inp-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelected),
      expression: "allSelected"
    }],
    attrs: {
      "id": "allSelected",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, null) > -1 : (_vm.allSelected)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.allSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelected = $$c
        }
      }, function($event) {
        _vm.allSelectedChanged()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "allSelected"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-name",
    attrs: {
      "title": "Nom / Prénom"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('FullName')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nom / Prénom")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('FullName', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('FullName', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-salarie",
    attrs: {
      "title": "N° Salarié"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('Numero')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("N° Salarié")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Numero', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Numero', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-contrat",
    attrs: {
      "title": "N° Contrat"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('NumeroContrat')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("N° Contrat")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('NumeroContrat', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('NumeroContrat', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-qualification",
    attrs: {
      "title": "Qualification"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('Qualification')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Qualification")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Qualification', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Qualification', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-entree",
    attrs: {
      "title": "Date entrée"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('DateEntree')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Date entrée")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('DateEntree', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('DateEntree', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-type",
    attrs: {
      "title": "Type Contrat"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('TypeContrat')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Type")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('TypeContrat', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('TypeContrat', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-indicateur",
    attrs: {
      "title": "État"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('Indicateurs')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("État")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Indicateurs', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Indicateurs', true)
  })])]), _vm._v(" "), _vm._m(0)])]) : _vm._e(), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "tbody"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.salariesFiltred), function(item) {
    return _c('div', {
      staticClass: "tr",
      class: _vm.contratSelectionne && item.IdContrat === _vm.contratSelectionne.IdContrat ? 'active' : '',
      attrs: {
        "data-testid": "calculPaie-row",
        "data-salarie": item.FullName
      }
    }, [_c('div', {
      staticClass: "td cln-check center-flex",
      on: {
        "click": function($event) {
          _vm.click_check('selected' + item.IdContrat + '_v')
        }
      }
    }, [_c('div', {
      staticClass: "inp-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selected),
        expression: "item.selected"
      }],
      attrs: {
        "id": 'selected' + item.IdContrat + '_v',
        "type": "checkbox",
        "data-testid": "calculPaie-row-checkbox",
        "data-salarie": item.FullName
      },
      domProps: {
        "checked": Array.isArray(item.selected) ? _vm._i(item.selected, null) > -1 : (item.selected)
      },
      on: {
        "change": function($event) {
          var $$a = item.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "selected", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label')])]), _vm._v(" "), _c('div', {
      staticClass: "td cln-name",
      attrs: {
        "title": item.FullName
      },
      on: {
        "click": function($event) {
          _vm.selectContrat(item)
        }
      }
    }, [(item.Photo != '') ? _c('img', {
      staticClass: "photo",
      attrs: {
        "src": item.Photo,
        "alt": "Photo"
      }
    }) : _c('span', {
      staticClass: "photo",
      style: ({
        background: _vm.randomColor(item.Id)
      })
    }, [_vm._v(_vm._s(item.Initiales))]), _vm._v(" "), _c('span', {
      staticClass: "name ml-2",
      attrs: {
        "data-testid": "calculPaie-salarie-name",
        "data-salarie": item.FullName
      }
    }, [_vm._v(_vm._s(item.FullName))])]), _vm._v(" "), _c('div', {
      staticClass: "td cln-salarie text-center",
      on: {
        "click": function($event) {
          _vm.selectContrat(item)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.Numero) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-contrat text-center",
      attrs: {
        "title": item.NumeroContrat
      },
      on: {
        "click": function($event) {
          _vm.selectContrat(item)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.NumeroContrat) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-qualification",
      on: {
        "click": function($event) {
          _vm.selectContrat(item)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.Qualification) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-entree text-center",
      on: {
        "click": function($event) {
          _vm.selectContrat(item)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(item.DateEntree, "DD/MM/YY")) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-type text-center",
      on: {
        "click": function($event) {
          _vm.selectContrat(item)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.NatureContrat) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-indicateur center-flex",
      on: {
        "click": function($event) {
          _vm.selectContrat(item)
        }
      }
    }, [(item.PaieDuMoisCalcule && !item.ARecalculer) ? _c('span', {
      staticClass: "circle circle-green",
      attrs: {
        "data-testid": "calculPaie-etat",
        "data-etat": "Calcule",
        "title": "Calculé"
      }
    }) : _vm._e(), _vm._v(" "), (item.ARecalculer) ? _c('span', {
      staticClass: "circle circle-orange",
      attrs: {
        "data-testid": "calculPaie-etat",
        "data-etat": "ARecalculer",
        "title": "En attente de re-calcul"
      }
    }) : _vm._e(), _vm._v(" "), (!item.PaieDuMoisCalcule && !item.ARecalculer) ? _c('span', {
      staticClass: "circle",
      attrs: {
        "data-testid": "calculPaie-etat",
        "data-etat": "ACalculer",
        "title": "À calculer"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "td cln-action center-flex"
    }, [_c('button', {
      staticClass: "inp-button blue",
      attrs: {
        "type": "button",
        "title": "Télécharger le bulletin",
        "disabled": !item.PaieDuMoisCalcule
      },
      on: {
        "click": function($event) {
          _vm.downloadPdf(item.IdContrat)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-file-download"
    })]), _vm._v(" "), _c('button', {
      staticClass: "inp-button turquoise ml-2",
      attrs: {
        "type": "button",
        "title": "Option"
      },
      on: {
        "click": function($event) {
          _vm.openToolTips(item.IdContrat)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-ellipsis-h"
    })]), _vm._v(" "), (item.seenTooltip) ? _c('div', {
      staticClass: "tips"
    }, [_c('div', {
      staticClass: "tips-line",
      on: {
        "click": function($event) {
          _vm.openSalarie(item.Id, item.FullName)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v("Voir son profil")])]), _vm._v(" "), _c('div', {
      staticClass: "tips-line",
      on: {
        "click": function($event) {
          _vm.ajouterAbsence(item.Id, item.IdContrat, item.FullName)
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v("Ajouter une absence")])]), _vm._v(" "), _c('div', {
      staticClass: "tips-line",
      on: {
        "click": function($event) {
          _vm.ajouterVariable(item.FullName)
        }
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v("Ajouter une variable")])])]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.dataReady) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('loader')], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "right noselect"
  }, [_c('div', {
    staticClass: "area",
    attrs: {
      "data-testid": "calculPaie-preview"
    }
  }, [_c('div', {
    staticClass: "head mb-2"
  }, [_c('div', {
    staticClass: "title-head",
    attrs: {
      "data-testid": "calculPaie-preview-title"
    }
  }, [_vm._v("\n\t\t\t\t\t\tPrévisualisation du bulletin\n\t\t\t\t\t\t"), (_vm.contratSelectionne && _vm.contratSelectionne.FullName != '') ? _c('span', {
    attrs: {
      "title": _vm.contratSelectionne.FullName
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t- " + _vm._s(_vm.contratSelectionne.FullName) + "\n\t\t\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inp-box p-0"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "box"
  }, [(!_vm.contratSelectionne || !_vm.contratSelectionne.PaieDuMoisCalcule) ? _c('div', {
    staticClass: "empty",
    attrs: {
      "data-testid": "calculPaie-preview-empty"
    }
  }, [_vm._m(5)]) : (_vm.currentDataUrl != undefined) ? _c('div', {
    staticClass: "box-object",
    attrs: {
      "data-testid": "calculPaie-preview-pdf"
    }
  }, [_c('object', {
    staticClass: "object",
    attrs: {
      "data": _vm.currentDataUrl,
      "type": "application/pdf"
    }
  })]) : _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('loader')], 1)])]) : _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('loader')], 1)])])])])]), _vm._v(" "), _c('modal-edition-bulletins', {
    ref: "modalEditionBulletins"
  }), _vm._v(" "), _c('modal-arret-sur-image', {
    ref: "modalArretSurImage",
    on: {
      "Suivant": _vm.arretSuivant
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-action nohover",
    attrs: {
      "title": "Actions"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Actions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-check"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-name"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-salarie"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-contrat"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-qualification"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-entree"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-type"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-indicateur"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-action"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "fas fa-user fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "left"
  }, [_c('i', {
    staticClass: "fas fa-plus fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "left"
  }, [_c('i', {
    staticClass: "fas fa-plus fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "icon fas fa-info-circle fa-4x mb-2"
  }), _vm._v(" "), _c('div', [_vm._v("Aucune édition sélectionnée.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84444dd0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calculDePaie/calculDePaie.vue.html
// module id = ATYU
// module chunks = 2